import React from 'react';
import { Alert } from 'aha-components';
import { useTranslation } from 'react-i18next';
import { useMultiplePricesStore } from '@/hooks/useMultiplePricesStore';
import { useDetailDataStore } from '@/hooks/useDetailDataStore';
import {
  formatScheduleConflictDateRange,
  hasSubmittedScheduleConflict
} from '@/utils/creatorScheduleConflict';

/** Pricing details 中随档期选择实时变化的摘要卡片。 */
const CreatorScheduleConflictSummary: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { creatorScheduleConflict } = useMultiplePricesStore();
  const { detailData } = useDetailDataStore();
  const orderScheduleConflict = detailData?.order?.scheduleConflict;
  // 再次报价时沿用订单首次提交的数据；首次报价才读取当前表单状态。
  const scheduleConflict = hasSubmittedScheduleConflict(orderScheduleConflict)
    ? orderScheduleConflict
    : creatorScheduleConflict;
  const { status, unavailableStartDate, unavailableEndDate, notes } =
    scheduleConflict;

  if (status === 'no') {
    return (
      <Alert
        className="w-full"
        type="success"
        showIcon
        title={t('price.fields.schedule_conflict.no_conflict_title', {
          defaultValue: 'No known scheduling conflicts'
        })}
        description={t(
          'price.fields.schedule_conflict.no_conflict_description',
          {
            defaultValue: 'Continue with the normal collaboration process.'
          }
        )}
      />
    );
  }

  const dateRange = formatScheduleConflictDateRange(
    unavailableStartDate,
    unavailableEndDate,
    i18n.resolvedLanguage || i18n.language
  );
  const trimmedNotes = typeof notes === 'string' ? notes.trim() : '';
  const description = trimmedNotes
    ? `${dateRange}  ${trimmedNotes}`
    : dateRange;

  return (
    <Alert
      className="w-full"
      type="warning"
      showIcon
      title={t('price.fields.schedule_conflict.alert_title', {
        defaultValue: 'Scheduling conflict added'
      })}
      description={description}
    />
  );
};

export default CreatorScheduleConflictSummary;
